import React, { memo, useCallback, useMemo } from 'react';
import { Breadcrumb, BreadcrumbItem, Table } from 'reactstrap';
import { FileResponse, FolderResponse, FolderId } from '@business/entities/file';
import { R } from '@core/utils/r';
import { FileService } from '@business/services';
import { CBreadcrumb, CBreadcrumbItem } from '../Breadcrumb';
export interface SearchListProps {
  items: (FileResponse | FolderResponse)[];
  onClick(item: FileResponse | FolderResponse): void;
  onBreadcrumb(id: FolderId): void;
}
export const SearchList = memo((props: SearchListProps) => {
  const getSize = useCallback((item: FileResponse | FolderResponse) => {
    if (item.type === 'folder') {
      return `${item.files} Files`;
    }

    if (item.fileType === 'file') {
      return FileService.getSize((item as FileResponse).size);
    }
    return '';
  }, []);

  const getType = useCallback((item: FileResponse | FolderResponse) => {
    if (item.type === 'folder') {
      return `Folder`;
    }

    return R.upperFirst(item.fileType);
  }, []);

  return (
    <React.Fragment>
      <div className="table-responsive">
        <Table className="table table-centered table-nowrap table-hover mb-0">
          <thead>
            <tr>
              <th scope="col" className="border-top-0">
                Name
              </th>
              <th scope="col" className="border-top-0">
                Path
              </th>
              <th scope="col" className="border-top-0">
                Type
              </th>
              <th scope="col" className="border-top-0">
                Size
              </th>
            </tr>
          </thead>
          <tbody>
            {props.items.map((item, key) => {
              const breadcrumbItems: CBreadcrumbItem[] = [{ name: 'Files', id: '0' }, ...(item.breadcrumbs ?? [])].map(b => ({
                title: b.name,
                onClick: () => props.onBreadcrumb(b.id),
              }));

              return (
                <tr key={key}>
                  <td style={{ maxWidth: 220 }}>
                    <div className="text-truncate">
                      <a className="text-dark font-weight-medium" onClick={() => props.onClick(item)}>
                        <i className={`pr-1 ${FileService.getIcon(item.name, item)}`} style={{ verticalAlign: 'middle' }}></i> {item.name}
                      </a>
                    </div>
                  </td>
                  <td>
                    <CBreadcrumb items={breadcrumbItems} listClassName="m-0 py-0" />
                  </td>
                  <td>{getType(item)}</td>
                  <td>{getSize(item)}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </React.Fragment>
  );
});
